type Props = {
  close: () => void;
  children: React.ReactNode;
};

export const Modal = (props: Props) => {
  return (
    <div className="modal" onClick={props.close}>
      <div
        className="modal-content"
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        {props.children}
      </div>
    </div>
  );
};
